import type { InstallableLocale } from "./preparedLocales";
import { useWorkspaceCopy } from "./workspaceCatalog";
import { formatMessage, type MessageValues } from "./catalogUtils";
export const RICH_TEXT_MESSAGES={
  "en": {
    "formatting": "Text formatting",
    "bold": "Bold",
    "italic": "Italic",
    "underline": "Underline",
    "bullets": "Bulleted list",
    "numbers": "Numbered list",
    "insertLink": "Insert link",
    "cancelLink": "Cancel link",
    "confirmLink": "Confirm link",
    "safeFormatting": "Safe formatting only; raw HTML is not supported.",
    "url": "URL",
    "linkError": "Use HTTPS, HTTP, an internal /path, or an approved URL variable.",
    "previewEmpty": "Preview will appear here.",
    "characters": "{count} / {limit} characters",
    "text": "text",
    "listItem": "List item",
    "linkText": "link text",
    "body": "Body"
  },
  "fa": {
    "formatting": "قالب‌بندی متن",
    "bold": "پررنگ",
    "italic": "مورب",
    "underline": "زیرخط",
    "bullets": "فهرست نشانه‌دار",
    "numbers": "فهرست شماره‌دار",
    "insertLink": "درج پیوند",
    "cancelLink": "لغو پیوند",
    "confirmLink": "تأیید پیوند",
    "safeFormatting": "فقط قالب‌بندی امن؛ HTML خام پشتیبانی نمی‌شود.",
    "url": "نشانی پیوند",
    "linkError": "از HTTPS، HTTP، مسیر داخلی /path یا متغیر نشانی مجاز استفاده کنید.",
    "previewEmpty": "پیش‌نمایش اینجا نمایش داده می‌شود.",
    "characters": "{count} از {limit} نویسه",
    "text": "متن",
    "listItem": "مورد فهرست",
    "linkText": "متن پیوند",
    "body": "متن"
  },
  "ar": {
    "formatting": "تنسيق النص",
    "bold": "عريض",
    "italic": "مائل",
    "underline": "تحته خط",
    "bullets": "قائمة نقطية",
    "numbers": "قائمة مرقمة",
    "insertLink": "إدراج رابط",
    "cancelLink": "إلغاء الرابط",
    "confirmLink": "تأكيد الرابط",
    "safeFormatting": "تنسيق آمن فقط؛ HTML الخام غير مدعوم.",
    "url": "عنوان الرابط",
    "linkError": "استخدم HTTPS أو HTTP أو مسار /path داخلياً أو متغير رابط معتمداً.",
    "previewEmpty": "ستظهر المعاينة هنا.",
    "characters": "{count} من {limit} حرفاً",
    "text": "نص",
    "listItem": "عنصر قائمة",
    "linkText": "نص الرابط",
    "body": "النص"
  },
  "it": {
    "formatting": "Formattazione testo",
    "bold": "Grassetto",
    "italic": "Corsivo",
    "underline": "Sottolineato",
    "bullets": "Elenco puntato",
    "numbers": "Elenco numerato",
    "insertLink": "Inserisci collegamento",
    "cancelLink": "Annulla collegamento",
    "confirmLink": "Conferma collegamento",
    "safeFormatting": "Solo formattazione sicura; HTML grezzo non supportato.",
    "url": "URL",
    "linkError": "Usa HTTPS, HTTP, un percorso interno /path o una variabile URL approvata.",
    "previewEmpty": "L’anteprima apparirà qui.",
    "characters": "{count} / {limit} caratteri",
    "text": "testo",
    "listItem": "Voce elenco",
    "linkText": "testo del collegamento",
    "body": "Testo"
  },
  "ru": {
    "formatting": "Форматирование текста",
    "bold": "Жирный",
    "italic": "Курсив",
    "underline": "Подчёркнутый",
    "bullets": "Маркированный список",
    "numbers": "Нумерованный список",
    "insertLink": "Вставить ссылку",
    "cancelLink": "Отменить ссылку",
    "confirmLink": "Подтвердить ссылку",
    "safeFormatting": "Только безопасное форматирование; исходный HTML не поддерживается.",
    "url": "URL",
    "linkError": "Используйте HTTPS, HTTP, внутренний /path или разрешённую переменную URL.",
    "previewEmpty": "Здесь появится предпросмотр.",
    "characters": "{count} / {limit} символов",
    "text": "текст",
    "listItem": "Элемент списка",
    "linkText": "текст ссылки",
    "body": "Текст"
  },
  "es": {
    "formatting": "Formato de texto",
    "bold": "Negrita",
    "italic": "Cursiva",
    "underline": "Subrayado",
    "bullets": "Lista con viñetas",
    "numbers": "Lista numerada",
    "insertLink": "Insertar enlace",
    "cancelLink": "Cancelar enlace",
    "confirmLink": "Confirmar enlace",
    "safeFormatting": "Solo formato seguro; no se admite HTML sin procesar.",
    "url": "URL",
    "linkError": "Usa HTTPS, HTTP, una ruta interna /path o una variable URL aprobada.",
    "previewEmpty": "Aquí aparecerá la vista previa.",
    "characters": "{count} / {limit} caracteres",
    "text": "texto",
    "listItem": "Elemento de lista",
    "linkText": "texto del enlace",
    "body": "Texto"
  },
  "fr": {
    "formatting": "Formatage du texte",
    "bold": "Gras",
    "italic": "Italique",
    "underline": "Souligné",
    "bullets": "Liste à puces",
    "numbers": "Liste numérotée",
    "insertLink": "Insérer un lien",
    "cancelLink": "Annuler le lien",
    "confirmLink": "Confirmer le lien",
    "safeFormatting": "Formatage sécurisé uniquement ; le HTML brut n’est pas pris en charge.",
    "url": "URL",
    "linkError": "Utilisez HTTPS, HTTP, un chemin interne /path ou une variable URL approuvée.",
    "previewEmpty": "L’aperçu apparaîtra ici.",
    "characters": "{count} / {limit} caractères",
    "text": "texte",
    "listItem": "Élément de liste",
    "linkText": "texte du lien",
    "body": "Texte"
  },
  "de": {
    "formatting": "Textformatierung",
    "bold": "Fett",
    "italic": "Kursiv",
    "underline": "Unterstrichen",
    "bullets": "Aufzählung",
    "numbers": "Nummerierte Liste",
    "insertLink": "Link einfügen",
    "cancelLink": "Link abbrechen",
    "confirmLink": "Link bestätigen",
    "safeFormatting": "Nur sichere Formatierung; rohes HTML wird nicht unterstützt.",
    "url": "URL",
    "linkError": "Verwenden Sie HTTPS, HTTP, einen internen /path oder eine genehmigte URL-Variable.",
    "previewEmpty": "Hier erscheint die Vorschau.",
    "characters": "{count} / {limit} Zeichen",
    "text": "Text",
    "listItem": "Listenelement",
    "linkText": "Linktext",
    "body": "Text"
  },
  "tr": {
    "formatting": "Metin biçimlendirme",
    "bold": "Kalın",
    "italic": "İtalik",
    "underline": "Altı çizili",
    "bullets": "Madde işaretli liste",
    "numbers": "Numaralı liste",
    "insertLink": "Bağlantı ekle",
    "cancelLink": "Bağlantıyı iptal et",
    "confirmLink": "Bağlantıyı onayla",
    "safeFormatting": "Yalnızca güvenli biçimlendirme; ham HTML desteklenmez.",
    "url": "URL",
    "linkError": "HTTPS, HTTP, dahili /path veya onaylı URL değişkeni kullanın.",
    "previewEmpty": "Önizleme burada görünecek.",
    "characters": "{count} / {limit} karakter",
    "text": "metin",
    "listItem": "Liste öğesi",
    "linkText": "bağlantı metni",
    "body": "Metin"
  },
  "uk": {
    "formatting": "Форматування тексту",
    "bold": "Жирний",
    "italic": "Курсив",
    "underline": "Підкреслений",
    "bullets": "Маркований список",
    "numbers": "Нумерований список",
    "insertLink": "Вставити посилання",
    "cancelLink": "Скасувати посилання",
    "confirmLink": "Підтвердити посилання",
    "safeFormatting": "Лише безпечне форматування; вихідний HTML не підтримується.",
    "url": "URL",
    "linkError": "Використовуйте HTTPS, HTTP, внутрішній /path або дозволену змінну URL.",
    "previewEmpty": "Тут з’явиться перегляд.",
    "characters": "{count} / {limit} символів",
    "text": "текст",
    "listItem": "Елемент списку",
    "linkText": "текст посилання",
    "body": "Текст"
  },
  "zh-cn": {
    "formatting": "文本格式",
    "bold": "粗体",
    "italic": "斜体",
    "underline": "下划线",
    "bullets": "项目符号列表",
    "numbers": "编号列表",
    "insertLink": "插入链接",
    "cancelLink": "取消链接",
    "confirmLink": "确认链接",
    "safeFormatting": "仅支持安全格式；不支持原始 HTML。",
    "url": "网址",
    "linkError": "请使用 HTTPS、HTTP、内部 /path 或已批准的网址变量。",
    "previewEmpty": "预览将显示在此处。",
    "characters": "{count} / {limit} 个字符",
    "text": "文本",
    "listItem": "列表项",
    "linkText": "链接文本",
    "body": "正文"
  },
  "sv": {
    "formatting": "Textformatering",
    "bold": "Fet",
    "italic": "Kursiv",
    "underline": "Understruken",
    "bullets": "Punktlista",
    "numbers": "Numrerad lista",
    "insertLink": "Infoga länk",
    "cancelLink": "Avbryt länk",
    "confirmLink": "Bekräfta länk",
    "safeFormatting": "Endast säker formatering; rå HTML stöds inte.",
    "url": "URL",
    "linkError": "Använd HTTPS, HTTP, en intern /path eller en godkänd URL-variabel.",
    "previewEmpty": "Förhandsvisningen visas här.",
    "characters": "{count} / {limit} tecken",
    "text": "text",
    "listItem": "Listobjekt",
    "linkText": "länktext",
    "body": "Text"
  }
} as const;
type Key=keyof typeof RICH_TEXT_MESSAGES.en;
export function richTextMessage(locale:InstallableLocale,key:Key,values?:MessageValues):string{return formatMessage(RICH_TEXT_MESSAGES[locale][key],values);}
export function useRichTextCopy(){const {locale}=useWorkspaceCopy();return (key:Key,values?:MessageValues)=>richTextMessage(locale,key,values);}
